var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91669 0.5C6.61657 0.5 7.28778 0.763392 7.78267 1.23223C8.27756 1.70107 8.55558 2.33696 8.55558 3C8.55558 3.66304 8.27756 4.29893 7.78267 4.76777C7.28778 5.23661 6.61657 5.5 5.91669 5.5C5.21682 5.5 4.5456 5.23661 4.05072 4.76777C3.55583 4.29893 3.2778 3.66304 3.2778 3C3.2778 2.33696 3.55583 1.70107 4.05072 1.23223C4.5456 0.763392 5.21682 0.5 5.91669 0.5ZM5.91669 6.75C8.83267 6.75 11.1945 7.86875 11.1945 9.25V10.5H0.638916V9.25C0.638916 7.86875 3.00072 6.75 5.91669 6.75Z",
    fill: "#5881FE",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cd4f7cf24a5c4f8f1f89b553c5587453.svg";
export { ForwardRef as ReactComponent };